import * as React from 'react';

import { Text } from '@notino/react-styleguide';

import { messages } from './messages';
import { DrawerProps } from './types';

export const SHADEFINDER_CONFIG = {
  background: '#f5e8e1',
  shades: {
    ultraBright: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/1eweb-1-1.jpg',
      label: messages.ultraBright,
    },
    bright: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/2dweb-1-1.jpg',
      label: messages.bright,
    },
    medium: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/3dweb-1-1.jpg',
      label: messages.medium,
    },
    mediumDark: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/4fweb-1-1.jpg',
      label: messages.mediumDark,
    },
    dark: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/5fweb-1-1.jpg',
      label: messages.dark,
    },
  },
  undertone: {
    cold: {
      color: '#E1A9C426',
      title: messages.undertoneCold,
      indicatorText: messages.undertoneColdIndicator,
      description: messages.undertoneColdDescription,
    },
    neutral: {
      color: '#FFF',
      title: messages.undertoneNeutral,
      indicatorText: messages.undertoneNeutralIndicator,
      description: messages.undertoneNeutralDescription,
    },
    warm: {
      color: '#FFD2551A',
      title: messages.undertoneWarm,
      indicatorText: messages.undertoneWarmIndicator,
      description: messages.undertoneWarmDescription,
    },
  },
  swatches: {
    lighter: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/est0031/6C1.jpg',
      title: messages.swatchLighter,
      description: messages.swatchLighterDescription,
    },
    ideal: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/est0031/6C2.jpg',
      title: messages.swatchIdeal,
      description: messages.swatchIdealDescription,
    },
    darker: {
      imageUrl:
        'https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/est0031/8C1.jpg',
      title: messages.swatchDarker,
      description: messages.swatchDarkerDescription,
    },
  },
};

export const DRAWER_SHADEFINDER_CONFIG: DrawerProps = {
  initialPosition: 'top',
  allowResize: false,
  showFade: false,
  showProgress: true,
  background: SHADEFINDER_CONFIG.background,
  title: ({ currentStep, totalSteps }) =>
    (currentStep !== 0 || currentStep !== totalSteps) && (
      <>
        {/* dummy div just to make some element for flex justify-content */}
        {currentStep === 1 && <div style={{ width: '3.5rem' }} />}

        <Text typography="labelRegular400">
          {currentStep}/{totalSteps}
        </Text>
      </>
    ),
};
